module.exports = __webpack_public_path__ + "static/img/1_10_3.208c2aa8.jpg";